import type {
  ApiRatingPeriodBoundsDto,
  ApiUserPositionsResponse,
  MenuProfileModel,
  RatingPeriodModel,
} from '~/modules/main'

const normalizePosition = (
  position: number | null | undefined,
): number | null => {
  if (position == null || position < 1) {
    return null
  }

  return position
}

const mapPeriodBoundsToRatingPeriod = (
  bounds: ApiRatingPeriodBoundsDto | null | undefined,
): RatingPeriodModel => {
  if (bounds == null) {
    return { from: '', to: '' }
  }

  return {
    from: bounds.startDate ?? '',
    to: bounds.endDate ?? '',
  }
}

export const mapUserPositionsResponse = (
  response: ApiUserPositionsResponse,
): MenuProfileModel => {
  const { previous, current } = response
  const publicId = current?.publicId ?? previous?.publicId

  return {
    ratingPeriod: mapPeriodBoundsToRatingPeriod(response.previousPeriod),
    userPlace: normalizePosition(previous?.position),
    title: previous?.title?.trim() ?? '',
    userId: publicId != null ? String(publicId) : '',
    previousSpinsCount: previous?.spinsCount ?? 0,
    currentSpinsCount: current?.spinsCount ?? 0,
  }
}
